import { useDataChange } from 'Simple/Data.js'

export default function useListItemDataOnChange(props) {
  let change = useDataChange({
    context: 'selected',
    viewPath: props.viewPath,
  })

  return function onChange(action) {
    change(next => {
      next.data.new_task = {
        ...next.data.new_task,
        actions: [action],
      }
    })
  }
}
